import styled, {css} from "styled-components"
import { motion } from "framer-motion"
import { AiOutlineFileText } from "react-icons/ai";
import { FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";


const OrdersIcon = styled(AiOutlineFileText)`
  color: ${props => props.theme.color};
  margin: 0 10px;
`

const LongArrowUp = styled(FaLongArrowAltUp)`
  color: ${props => props.active ? props.theme.mainBg : props.theme.color};
`

const LongArrowDown = styled(FaLongArrowAltDown)`
  color: ${props => props.active ? props.theme.mainBg : props.theme.color};
`

const TabButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const OrdersBtn = styled.div`
    background-color: ${props => props.theme.tradeBg};
    padding: 10px 15px;
    border-radius: 4px;
    box-shadow: 0 0 5px solid ${props => props.theme.secondaryBg};
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
`

const TabWrapper = styled.div`
    height: 160px;
    width: 80%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  
  @media screen and (max-width: 768px) {
    width: 90%;
  }
`

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    margin-top: 80px;
    z-index: 10;
    background-color: ${props => props.theme.mainBg};
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    padding-bottom: 200px;
    box-shadow: 0 0 2px black;
    //position: relative;
`

const OtcTabBody = styled.div`
    border-radius: 25px;
    display: flex;
      justify-content: center;
      align-items: center;
    min-width: 140px; 
    margin: 0 20px;
    padding: 0 10px;
    background-color: ${props => props.active ? props.theme.mainOrange : "transparent"};
    cursor: pointer;
    transition: all 0.3s;
  
  @media screen and (max-width: 1050px) {
    margin: 0 8px;
    padding: 0;
  min-width: 100px;
  }
`

const OtcTabText = styled.h3`
    font-size: 1rem;
    color: ${props => ( props.active && "black" ) || props.theme.color};
    font-weight: 500;
    transition: all 0.3s;
  
  @media screen and (max-width: 1050px) {
    font-size: 0.8rem;
  }
`

const CoinSelectContainer = styled.div`
    width: 40%;
    align-self: center;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (max-width: 1050px){
      width: 70%;
    }
  
    @media only screen and (max-width: 768px) {
      flex-direction: column-reverse;
    }
`

const OtcMarketBody = styled(motion.div)`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 65vh;
`


const StyledNumberFormat = styled.input`
    width: ${props =>
        (props.typeOnSelect && "50%") ||
        (props.typeOnPro && "100%") ||
        (props.typeOnBound && "100%") ||
        "40%"};
    padding: 0 20px;
    top: 0;
    left: 0;
    align-self: center;
    height: 48px;
    color: ${props => props.theme.color};
    background-color: ${props => props.theme.otcInput};
    border-radius: 4px;
    border: none;
    ${props => props.theme.english && css`
        // font-family: monospace;
        font-size: 13px;
    `}

    &:focus{
        border: 0.5px solid #FCD535;
        background-color: ${props => props.background};
    }

    @media only screen and (max-width: 1050px){
      width: ${props =>
        (props.typeOnSelect && "50%") ||
        (props.typeOnPro && "100%") ||
        (props.typeOnBound && "100%") ||
        "70%"};
    }
  
  @media only screen and (max-width: 768px) {
    width: ${props =>
            (props.typeOnSelect && "100%")};
    
    };
  }
`


const BuySellButton = styled.div`
    width: ${props => (props.typeOnPro && "100%") || "40%"};
    margin-top: 16px;
    height: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background-image: ${props => (props.active && 
        "linear-gradient(180deg, #F8D12F 0%, #599eff 100%)") || 
         `linear-gradient(180deg, ${props.theme.input} 0%, ${props.theme.input}95 100%)`};
    align-self: center;
    color: ${props => props.active ? props.theme.primaryBg : props.theme.color };
    font-weight: 500;
    // letter-spacing: 1.5px;
    font-size: 1.05rem;
    cursor: ${props => (props.active && "pointer") || "not-allowed"};
    transition: all 0.3s;
    
    ${props => props.warning && css`
      cursor: pointer;
    `};

    &:hover{
      background-image: ${props => (props.active && 
      "linear-gradient(180deg, #599eff 0%, #F8D12F 100%)" ) ||
      "#eaecef"};
    }

    @media only screen and (max-width: 960px){
        width: ${props => (props.typeOnPro && "100%") || "70%"};
    }

`

const WarningBody = styled(motion.div)`
    width: fit-content;
    border-radius: 5px;
    box-shadow: 0 0 2px black,
    0 0 4px #00000095;
    padding: 10px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 20px;
    z-index: 1000000;
    left: 0;
    right: 0;
    margin: 0 auto;
    align-self: center;
    background-color: #5F6C6E;
`

const WarningText = styled.div`
    margin-top: 2px;
    font-size: 14px !important;
    font-weight: 600;
    // letter-spacing: 1.1px;
    color: #E1E0CB !important;
    text-shadow: 0 0 1px black;
`

const OtcMainContent = styled.div`
    width: 100%;
    height: fit-content;
    justify-content: center;
    align-items: center;
`


const BoundItem = styled.div`
  width: 47%;
`

const Label = styled.h3`
  width: 40%;
  align-self: center;
  color: ${props => props.theme.color};
  text-align: start;
  font-size: ${props => props.fontSize || "13px"};
  font-weight: 600;
  padding: 0 2px;
  // letter-spacing: 1.2px;
  position: relative;
  margin-top: ${props => (props.typeOnSelect && 0) || ((props.typeOnPro || props.typeOnBound) && "40px") || "60px"};

  @media only screen and (max-width: 1050px){
      width: ${props => 
        (props.typeOnSelect && "70%") || 
        (props.typeOnPro && "100%") || 
        (props.typeOnBound && "100%") || 
        "70%"};
    margin-top: ${props => (props.typeOnSelect && 0) || ((props.typeOnPro || props.typeOnBound) && "20px") || "30px"};
    font-size: 0.75rem;
  }
`

const BoundsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`


const OtcLimitBody = styled(motion.div)`
    display: flex;
    width: 80%;
    margin: 0 auto;
    justify-content: space-evenly;
    height: fit-content;

    @media only screen and (max-width: 1050px){
      flex-direction: column-reverse;
    };
      @media only screen and (max-width: 768px){
        flex-direction: column-reverse;
        width: 100%;
      };
`

const OtcChart = styled.div`
  width: 50%;
  margin-top: 40px;
  margin-left: 40px;
  margin-right: 40px;

  @media only screen and (max-width: 1050px){
      width: 80%;
      height: 300px;
  }
`

const OtcLimitWrapper = styled.div`
  width: 50%;
  padding: 0 40px;

  @media only screen and (max-width: 1050px){
      width: 100%;
  }
`

const SwapBody = styled.div`
    width: 140px;
    border-radius: 8px;
    align-self: center;
    margin-top: 30px;
    /* background-color: #f5f5f5; */
    display: flex;
    align-items: center;
    justify-content: space-evenly;
`

const SwapButton = styled.div`
    width: 45%;
    background-color: ${props => props.active && props.theme.mainOrange};
    border-radius: 4px;
    display: flex;
    padding: 2px 4px;
    cursor: pointer;
    align-items: center;
`

const SwapText = styled.h3`
    color: ${props => props.active ? props.theme.mainBg : props.theme.color};
    font-size: ${props => (props.lang === "en" && "15px") || "14px"};
    // letter-spacing: 1.2px;
    font-weight: bold;
    margin: 0 3px;
    margin-top: 7px;

  @media screen and (max-width: 1050px) {
    font-size: 0.9rem;
  }
`

export {
    Wrapper,
    TabWrapper,
    OrdersBtn,
    TabButtonContainer,
    OtcTabBody,
    OtcTabText,
    BuySellButton,
    OtcMarketBody,
    StyledNumberFormat,
    // CoinSelect,
    CoinSelectContainer,
    WarningBody,
    WarningText,
    OtcMainContent,
    BoundItem,
    OtcLimitBody,
    OtcLimitWrapper,
    BoundsContainer,
    OtcChart,
    Label,
    OrdersIcon,
    SwapText,
    SwapButton,
    SwapBody,
    LongArrowUp,
    LongArrowDown
}